exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "", ""]);

// Exports
exports.locals = {
	"primary": "#ed2939",
	"secondary": "#3f9c35",
	"ternary": "#3f9c35",
	"disabled": "#7e8287",
	"text": "#04141e",
	"text-light": "#7e8287",
	"text-input": "#1d1d1d",
	"text-reverse": "#fff",
	"placeholder": "#b4b8ba",
	"border": "#d2d5d9",
	"page-bg": "#ebedee",
	"error": "#fa314a",
	"success": "#0ea036",
	"default": "#fff",
	"primary-light": "#ffe5e5",
	"secondary-light": "#eafae8",
	"info": "#faebd7",
	"info-border": "#fbb75b",
	"account-input": "#e3e3e3",
	"warning": "#fad9d9",
	"warning-border": "#fb6f88",
	"info-text": "#788186",
	"progress-bar": "#286c2d",
	"progress-bar-active": "#41e847"
};